/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".no-payment-alert[_ngcontent-%COMP%]{width:100%;height:35px;background-color:#ffc539;color:#fff;text-align:center;display:flex;align-items:center;justify-content:center;font-size:14px}.no-payment-alert[_ngcontent-%COMP%]   a[_ngcontent-%COMP%], .no-payment-alert[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:visited{color:#fff;text-decoration:underline}.no-payment-alert[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:active{color:#fff}.no-payment-alert[_ngcontent-%COMP%]   a[_ngcontent-%COMP%]:hover{color:red}"];
export { styles as styles };
